// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"7fb167ad","585":"b9a9c7c2","650":"b0be2424","703":"b13f1016"}[chunkId] + ".chunk.js";
};